import ApiService from '../api.service'

const DepartmentService = {

    getList() {
        return ApiService.get( `legal-department` )
    },

}

export default DepartmentService;
